exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.global-admin #connections-page .page-content {\n    min-height: calc(100vh - 90px);\n}\n", ""]);

// exports
